
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M21 27a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21.5 44c6.351 0 11.5-3.134 11.5-7s-5.149-7-11.5-7S10 33.134 10 37s5.149 7 11.5 7Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-account-organization__outline",attrs:{"d":"M42.5 23c0 5.053-2.025 9.632-5.31 12.971C34.904 30.973 29.859 27.5 24 27.5s-10.903 3.473-13.19 8.471A18.439 18.439 0 0 1 5.5 23C5.5 12.783 13.783 4.5 24 4.5S42.5 12.783 42.5 23Z","stroke":"#234652"}}),_c('circle',{staticClass:"i-account-organization__head",attrs:{"cx":"24","cy":"17","r":"7.5","stroke":"#234652"}})])
          )
        }
      }
    